import React, { useState } from "react";
import axios from "axios";
import { api_url } from "../config/config";
const Adddata = () => {
  const [formData, setFormData] = useState({
    product_code: "",
    name: "",
    description: "",
    manufacturer: "",
    product_type: "",
    concern: "",
    composition: "",
    pack_type: "",
    size: "",
    consume_type: "",
    price: "",
    discounted_price: "",
    discount_percent: "",
    expire_date: "",
    benefits: "",
    how_to_use: "",
    safety_advise: "",
    prescription_required: false,
    primary_use: "",
    storage_instruction: "",
    side_effects: "",
    quantity: "",
    return_policy: "",
    alternatives: "",
    key_ingredients: "",
    shelf_rack_no: "",
    concern_id: "",
    category_id: "",
    brand_id: "",
    images: [],
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${api_url}/product`, formData);
      setMessage(response.data.message || "Product added successfully!");
    } catch (error) {
      setMessage(error.response?.data?.message || "Failed to add product.");
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Add New Product</h1>
      <form onSubmit={handleSubmit} className="space-y-6 bg-white p-6 rounded shadow-md">
        {/* Input Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { label: "Product Code", name: "product_code" },
            { label: "Name", name: "name" },
            { label: "Description", name: "description" },
            { label: "Manufacturer", name: "manufacturer" },
            { label: "Product Type", name: "product_type" },
            { label: "Concern", name: "concern" },
            { label: "Composition", name: "composition" },
            { label: "Pack Type", name: "pack_type" },
            { label: "Size", name: "size" },
            { label: "Consume Type", name: "consume_type" },
            { label: "Price", name: "price" },
            { label: "Discounted Price", name: "discounted_price" },
            { label: "Discount Percent", name: "discount_percent" },
            { label: "Expire Date", name: "expire_date", type: "date" },
            { label: "Quantity", name: "quantity" },
            { label: "Return Policy", name: "return_policy" },
            { label: "Shelf Rack No", name: "shelf_rack_no" },
          ].map(({ label, name, type = "text" }) => (
            <div key={name}>
              <label htmlFor={name} className="block font-medium mb-1">
                {label}
              </label>
              <input
                type={type}
                id={name}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                className="w-full border rounded p-2"
              />
            </div>
          ))}
        </div>

        {/* Checkbox */}
        <div>
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="prescription_required"
              checked={formData.prescription_required}
              onChange={handleChange}
              className="border rounded"
            />
            <span>Prescription Required</span>
          </label>
        </div>

        {/* Multi-line Fields */}
        {[
          { label: "Benefits", name: "benefits" },
          { label: "How to Use", name: "how_to_use" },
          { label: "Safety Advise", name: "safety_advise" },
          { label: "Primary Use", name: "primary_use" },
          { label: "Storage Instruction", name: "storage_instruction" },
          { label: "Side Effects", name: "side_effects" },
          { label: "Alternatives", name: "alternatives" },
          { label: "Key Ingredients", name: "key_ingredients" },
        ].map(({ label, name }) => (
          <div key={name}>
            <label htmlFor={name} className="block font-medium mb-1">
              {label}
            </label>
            <textarea
              id={name}
              name={name}
              value={formData[name]}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
        ))}

        {/* Submit Button */}
        <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded">
          Add Product
        </button>
      </form>

      {/* Message */}
      {message && <p className="mt-4 text-center">{message}</p>}
    </div>
  );
};

export default Adddata;
